import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { WorkGridObject } from '@it2go/types';
import { ServiceService } from '../../../../../services/service.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../shared/shared.global-service';
import {
    selectCurrentServiceId,
    selectFolder,
    selectFolderId,
    selectServices,
} from '../../../store/person/person.selectors';
import { map } from 'rxjs/operators';
import { getSharingFolderIds } from '../../../../../utils/folder.utils';
import {
    SERVICE_SETTINGS_SPECIALIST_RECORD_TYPE_KEY,
} from '@libs/types/src/services/types/common-service-settings.type';

interface State {
    works: WorkGridObject | null,
}

const defaultState: State = {
    works: null,
};

@Injectable()
export class FolderSpecialistRecordsPageStore extends ComponentStoreFactory<State, ServiceService> {

    folder = toSignal(this.globalStore!.select(selectFolder));
    folderId = toSignal(this.globalStore!.select(selectFolderId));
    serviceId = toSignal(this.globalStore!.select(selectCurrentServiceId));

    specialistRecordSharingIds = toSignal(globalStore!.select(selectServices).pipe(
        map((services) =>
            getSharingFolderIds(this.serviceId(), services, this.folder()?.relatedFolders, SERVICE_SETTINGS_SPECIALIST_RECORD_TYPE_KEY),
        ),
    ));

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }
}